import { StyledButton, StyledForm, StyledFormField } from '@/components/styles'
import { useForm, FormContext } from 'react-hook-form'
import { FormField, Radio } from '@/components'
import { useState, useRef } from 'react'
import { regExp } from '@/lib/config'
import { useModal } from './Modal'
import api from '@/lib/api'
import { useTranslation } from "react-i18next";

export default function FeedBackForm() {
  const formMethods = useForm()
  const { handleSubmit, reset } = formMethods
  const { t } = useTranslation("global");

  const [status, setStatus] = useState({
    success: false,
    loading: false,
    error: false,
  })
  const errorInput = useRef()

  const handleError = () => {
    setStatus(prevStatus => ({ ...prevStatus, error: true }))
    errorInput.current.focus()
  }

  const onFormSubmit = async data => {
    setStatus(prevStatus => ({ ...prevStatus, loading: true }))

    try {
      const resp = await api.reviewsCreate(data)
      if (resp.result === 'success') {
        reset()
        setStatus(prevStatus => ({ ...prevStatus, loading: false, success: true }))
      } else {
        handleError()
      }
    } catch (error) {
      handleError()
    }
  }

  return status.success ? (
    <Success />
  ) : (
    <FormContext {...formMethods}>
      <StyledForm
        as="form"
        action="/"
        onSubmit={handleSubmit(onFormSubmit)}
        modal
        autoComplete="off"
      >
        <StyledForm.Title>{t('feedbackForm.title')}</StyledForm.Title>
        <StyledForm.Desc>
        {t('feedbackForm.desc')}
        </StyledForm.Desc>

        {status.error && (
          <StyledForm.Error ref={errorInput} value="Ошибка сервера, попробуйте позже" readOnly />
        )}

        <StyledForm.Block>
          <StyledForm.Row>
            <StyledForm.Item>
              <FormField label={t('feedbackForm.name')} name="name" validateRules={{ required: true }} autoFocus />
            </StyledForm.Item>

            <StyledForm.Item>
              <StyledFormField noDecor radio>
                <StyledFormField.Title>{t('feedbackForm.gender')}</StyledFormField.Title>
                <Radio name="gender" value="man">
                {t('feedbackForm.male')}
                </Radio>
                <Radio name="gender" value="woman" defaultChecked>
                {t('feedbackForm.female')}
                </Radio>
              </StyledFormField>
            </StyledForm.Item>
          </StyledForm.Row>

          <StyledForm.Row>
            <StyledForm.Item>
              <FormField label={t('feedbackForm.city')} name="city" />
            </StyledForm.Item>

            <StyledForm.Item>
              <FormField
                label="E-mail"
                name="email"
                type="text"
                inputmode="email"
                validateRules={{
                  validate: value => {
                    if (value.length < 1) {
                      return true
                    } else {
                      return regExp.email.test(value)
                    }
                  },
                }}
              />
            </StyledForm.Item>
          </StyledForm.Row>

          <StyledForm.Row>
            <StyledForm.Item>
              <FormField
                inputAs="textarea"
                label={t('feedbackForm.text')} 
                name="review"
                validateRules={{ required: true }}
              />
            </StyledForm.Item>
          </StyledForm.Row>
        </StyledForm.Block>

        <StyledForm.Submit>
          <StyledButton type="submit" disabled={status.loading} isLoading={status.loading}>
          {t('feedbackForm.submit')} 
            <StyledButton.Loader />
          </StyledButton>
        </StyledForm.Submit>
      </StyledForm>
    </FormContext>
  )
}

function Success() {
  const modal = useModal()
  const { closeModal } = modal
  const { t } = useTranslation("global");

  return (
    <StyledForm as="div" modal>
      <StyledForm.Title centered>{t('feedbackForm.thanks.title')} </StyledForm.Title>
      <StyledForm.Desc centered>{t('feedbackForm.thanks.desc')}</StyledForm.Desc>
      <StyledForm.Submit>
        <StyledButton type="button" onClick={closeModal}>
        {t('feedbackForm.thanks.button')}
        </StyledButton>
      </StyledForm.Submit>
    </StyledForm>
  )
}
